function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgSa = function SvgSa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#6DA544"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M144.696,306.087c0,18.441,14.95,33.391,33.391,33.391h100.174 c0,15.368,12.458,27.826,27.826,27.826h33.391c15.368,0,27.826-12.458,27.826-27.826v-33.391H144.696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M370.087,144.696v77.913c0,12.275-9.986,22.261-22.261,22.261v33.391 c30.687,0,55.652-24.966,55.652-55.652v-77.913H370.087z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M130.783,222.609c0,12.275-9.986,22.261-22.261,22.261v33.391c30.687,0,55.652-24.966,55.652-55.652 v-77.913h-33.391V222.609z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 144.696,
    style: {
      fill: "#F0F0F0"
    },
    width: 33.391,
    height: 77.913
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M269.913,189.217c0,3.069-2.497,5.565-5.565,5.565s-5.565-2.497-5.565-5.565v-44.522h-33.391v44.522 c0,3.069-2.497,5.565-5.565,5.565s-5.565-2.497-5.565-5.565v-44.522H180.87v44.522c0,21.481,17.476,38.957,38.957,38.957 c8.273,0,15.945-2.6,22.261-7.016c6.315,4.415,13.988,7.016,22.261,7.016c1.666,0,3.304-0.117,4.915-0.322 c-2.366,9.749-11.146,17.017-21.611,17.017v33.391c30.687,0,55.652-24.966,55.652-55.652v-33.391v-44.522h-33.391V189.217z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.87,
    y: 244.87,
    style: {
      fill: "#F0F0F0"
    },
    width: 50.087,
    height: 33.391
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sa.2dd9486f.svg";
export { ForwardRef as ReactComponent };